import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineLeftArrowToLeftIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 11H9.41l2.3-2.29a1.0052 1.0052 0 0 0 .2177-1.0943 1.0055 1.0055 0 0 0-.5435-.5434A1.0036 1.0036 0 0 0 10.29 7.29l-4 4a.9994.9994 0 0 0-.21.33 1 1 0 0 0 0 .76.9994.9994 0 0 0 .21.33l4 4a.9997.9997 0 0 0 1.42 0 .9997.9997 0 0 0 0-1.42L9.41 13H21a1.0001 1.0001 0 0 0 0-2ZM3 3a1 1 0 0 0-1 1v16a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineLeftArrowToLeftIcon
